var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeavy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    fill: "none",
    stroke: "#0000f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.931 35.293l-.231-.035a2 2 0 01-1.7-1.977V28a2 2 0 012-2h11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 26V15.5a2.5 2.5 0 00-2.5-2.5h0a2.5 2.5 0 00-2.5 2.5V40a6 6 0 006 6h0M36 28V13.5a2.5 2.5 0 012.5-2.5h0a2.5 2.5 0 012.5 2.5V40a6 6 0 01-6 6h0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.495 40.446a3 3 0 013-3l-4.242-4.243a2 2 0 010-2.828l1.414-1.415L38 34.104M22 45.191V51M37 45.633V51M35 58.562A28.979 28.979 0 1030 59"
  })))));
}
export default SvgHeavy;